 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHALFTITLE from '@/components/Text/halftitle'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTFOREWORD from '@/components/Text/foreword'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTACK from '@/components/Text/ack'
 import TEXTEPUB_9781605094106_6 from '@/components/Text/Epub_9781605094106_6'
 import TEXTEPUB_9781605094106_6T1 from '@/components/Text/Epub_9781605094106_6t1'
 import TEXTEPUB_9781605094106_7 from '@/components/Text/Epub_9781605094106_7'
 import TEXTEPUB_9781605094106_8 from '@/components/Text/Epub_9781605094106_8'
 import TEXTEPUB_9781605094106_9 from '@/components/Text/Epub_9781605094106_9'
 import TEXTEPUB_9781605094106_10 from '@/components/Text/Epub_9781605094106_10'
 import TEXTEPUB_9781605094106_11 from '@/components/Text/Epub_9781605094106_11'
 import TEXTEPUB_9781605094106_11T1 from '@/components/Text/Epub_9781605094106_11t1'
 import TEXTEPUB_9781605094106_12 from '@/components/Text/Epub_9781605094106_12'
 import TEXTEPUB_9781605094106_13 from '@/components/Text/Epub_9781605094106_13'
 import TEXTEPUB_9781605094106_14 from '@/components/Text/Epub_9781605094106_14'
 import TEXTEPUB_9781605094106_15 from '@/components/Text/Epub_9781605094106_15'
 import TEXTEPUB_9781605094106_16 from '@/components/Text/Epub_9781605094106_16'
 import TEXTEPUB_9781605094106_17 from '@/components/Text/Epub_9781605094106_17'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/halftitle",
 			"name" : "Text/halftitle",
 			"component" : TEXTHALFTITLE
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/foreword",
 			"name" : "Text/foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/Epub_9781605094106_6",
 			"name" : "Text/Epub_9781605094106_6",
 			"component" : TEXTEPUB_9781605094106_6
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js